export function getBoolean(value: any) {
    switch (value) {
        case true:
        case "true":
        case 1:
        case "1":
        case "on":
        case "yes":
            return true;
        default:
            return false;
    }
}

export function getRandomId(max: number = 9999) {
    return Math.floor(Math.random() * max).toString();
}

export function getCurrentTime() {
    return new Date().getTime();
}

export function getStandardDeviation(values: number[]) {
    const n = values.length;
    if (n < 1) {
        return 0;
    }
    const mean = values.reduce((total, value) => { return total + value; }, 0) / n;

    return Math.sqrt(values.map(x => Math.pow(x - mean, 2)).reduce((total, value) => { return total + value; }, 0) / n);
}

export function padLeft(value: string | number, padCharacter: string, length: number) {
    let val = value.toString();
    while (val.length < length) {
        val = padCharacter + val;
    }
    return val;
}

export function scrollElementIntoView(elem: HTMLElement | string) {
    let theElem = typeof elem === 'string' ? document.querySelector<HTMLElement>(elem) : elem;
    if (theElem === null) {
        return;
    }
    window.scrollTo({ top: theElem?.offsetTop - 10, behavior: "smooth" });
}

export function getPrintableCharacters(str: string) {
    return str.replace(/[^\x20-\x7E]/g, "");
}

export function debounce<T extends Function>(callback: T, wait = 300) {
    let h:number | NodeJS.Timeout = 0;
    let callable = (...args: any) => {
        clearTimeout(h);
        h = setTimeout(() => callback(...args), wait) ;
    };
    return <T>(<any>callable);
}

export function isEmpty(value: string | any[] | null | undefined) {
    if (Array.isArray(value)) {
        return value === undefined || value === null || value.length < 1;
    }
    return value === undefined || value === null || value === "";
}
